import { Mail, MapPin, Pencil, Phone, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { Avatar, Btn, Card, PageHeader } from "@/components/common";

const ROLE = { lawyer: "Advocate", staff: "Staff Member", client: "Client" };

const Row = ({ icon: Icon, label, value }) => (
  <div className="flex items-center gap-3 py-3.5">
    <div className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-amber-50 text-gold"><Icon size={17} /></div>
    <div className="min-w-0"><div className="text-xs text-slate-400">{label}</div><div className="truncate text-sm font-medium text-navy">{value}</div></div>
  </div>
);

export default function Profile() {
  const { user } = useAuth();
  return (
    <div>
      <PageHeader title={user.user_type === "client" ? "Profile" : "Settings"} subtitle="Your account information" />
      <Card data-testid="profile-card" className="max-w-2xl overflow-hidden">
        <div className="h-24 bg-navy" />
        <div className="px-5 pb-5 sm:px-6">
          <div className="-mt-8 flex items-end justify-between">
            <Avatar name={user.name} size="lg" className="ring-4 ring-white" />
            <Btn variant="outline" data-testid="edit-profile-button" onClick={() => toast("Demo mode — this action is visual only.")}><Pencil size={15} />Edit</Btn>
          </div>
          <h2 data-testid="profile-name" className="mt-3 font-heading text-xl font-bold text-navy">{user.name}</h2>
          <div className="text-sm text-slate-500">{ROLE[user.user_type]}</div>
          <div className="mt-4 divide-y divide-slate-100 border-t border-slate-100">
            <Row icon={Mail} label="Email" value={user.email} />
            <Row icon={Phone} label="Phone" value="+91 90000 00000" />
            <Row icon={MapPin} label="Location" value="Pune, Maharashtra" />
            <Row icon={ShieldCheck} label="Account type" value={user.user_type} />
          </div>
        </div>
      </Card>
    </div>
  );
}
